import { SET_REFUND_INFO } from './actions';
const initialState = null;
function refundInfoReducer(state = initialState, { type, payload }) {
    switch (type) {
        case SET_REFUND_INFO:
            return payload;
        default:
            return state;
    }
}
export default refundInfoReducer;
